import { MetricField, type MyLensesOrganicStatsResponseEntry } from "../../gql-generated/types";

import { extractMetricFromList } from "./extractMetricFromList";

export const ejectRetentionTotalValue = (
    responseEntryList: readonly MyLensesOrganicStatsResponseEntry[],
): { dauOverWau: number; dauOverMau: number } => {
    const [responseEntry] = responseEntryList;

    if (!responseEntry) {
        return {
            dauOverWau: 0,
            dauOverMau: 0,
        };
    }

    const list = responseEntry.statsResponseTimeEntryList[0]?.statsList ?? [];

    const dauOverWauDimension = extractMetricFromList(list, MetricField.LensDauOverWau);
    const dauOverMauDimension = extractMetricFromList(list, MetricField.LensDauOverMau);

    return {
        dauOverWau: Number.parseFloat(dauOverWauDimension?.statsList[0]?.value ?? ""),
        dauOverMau: Number.parseFloat(dauOverMauDimension?.statsList[0]?.value ?? ""),
    };
};
